import React from "react";
import { PlacePage } from "./place";

function App() {
  return <PlacePage />;
}

export default App;
